<template>
  <div class="plv-iar-default-red-envelope-error">
  </div>
</template>

<script>
import { showTip } from './showTip';
import langMixin from './langMixin';

/**
 * 单独设置该组件是因为一般 toast 会被红包组件遮罩
 */
export default {
  mixins: [langMixin],
  async mounted() {
    await showTip(this.iarTrans('redEnvelope.notOpenId'));
    this.$emit('close');
  }
};
</script>
